module.exports = __webpack_public_path__ + "img/icon-vehicle-type-n2.ea5c6d99.svg";